import Combobox from "@/components/Combobox";
import FormHeader from "@/components/FormHeader";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/axios";
import { getListJenisUkt } from "@/services/getData";
import { DataUktPendaftarLulus, JenisUkt } from "@/types";
import { AxiosError } from "axios";
import { Loader2 } from "lucide-react";
import { useState } from "react";
import toast from "react-hot-toast";
import { MdModeEdit } from "react-icons/md";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const postData = async (newData: {
  id_data_ukt_pendaftar_lulus: string;
  id_ref_jenis_ukt: string;
}) => {
  const response = await api.post(
    "/data-ukt-pendaftar-lulus/ubah-penetapan-ukt",
    newData,
  );
  return response.data;
};

export default function FormUKT({
  method,
  selectedRow,
  closeModal,
}: {
  method?: "POST" | "PATCH" | "DELETE";
  selectedRow?: DataUktPendaftarLulus | null;
  closeModal: () => void;
}) {
  console.log(method);
  const [openJenisUkt, setOpenJenisUkt] = useState(false);

  const [form, setForm] = useState({
    id_data_ukt_pendaftar_lulus: selectedRow?.id_data_ukt_pendaftar_lulus || "",
    id_ref_jenis_ukt: selectedRow?.ref_nominal_ukt?.id_ref_jenis_ukt || "",
  });

  const { data: listJenisUkt, isPending: isPendingListJenisUkt } = useQuery({
    queryKey: ["listJenisUkt"],
    queryFn: getListJenisUkt,
    select: (data) =>
      data?.map((jenisUkt: JenisUkt) => {
        return {
          label: jenisUkt.nama_jenis_ukt,
          value: `${jenisUkt.id_ref_jenis_ukt}`,
        };
      }),
  });

  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: postData,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: ["listDataUktPendaftarLulus"],
      });
      closeModal();
      toast.success(data?.message || "Success.");
    },
    onError: (error: AxiosError) => {
      const err = error as AxiosError<{ message?: string }>;
      toast.error(
        err?.response?.data?.message || "An unexpected error occurred.",
      );
    },
  });

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    mutate(form);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-y-3">
      <FormHeader icon={<MdModeEdit />} title={"Ubah UKT"} />

      <div>
        <Label>Nama</Label>
        <Input
          disabled
          value={selectedRow?.data_pendaftaran?.data_siswa?.nama_lengkap || ""}
        />
      </div>
      <div>
        <Label>Nomor Pendaftaran</Label>
        <Input
          disabled
          value={selectedRow?.data_pendaftaran?.nomor_pendaftaran || ""}
        />
      </div>
      <div>
        <Label>Jenis UKT</Label>
        <Combobox
          isPending={isPendingListJenisUkt}
          open={openJenisUkt}
          setOpen={setOpenJenisUkt}
          value={form.id_ref_jenis_ukt || ""}
          setValue={(value) => {
            setForm((prev) => ({ ...prev, id_ref_jenis_ukt: value }));
          }}
          options={listJenisUkt}
          placeholder="Pilih Jenis UKT"
        />
      </div>
      <Button className="mt-3 flex items-center gap-3" disabled={isPending}>
        {isPending ? (
          <>
            <Loader2 className="w-4 h-4 mr-1 animate-spin" />
            Processing...
          </>
        ) : (
          "Simpan"
        )}
      </Button>
    </form>
  );
}
